import Enum from "./Enum";

export default Enum.create( {
	PERMISSION_REQUEST_COMPLETED: "PERMISSION_REQUEST_COMPLETED",
	PERMISSION_REQUEST_INITIATED: "PERMISSION_REQUEST_INITIATED",
	PERMISSION_REQUEST_ERROR: "PERMISSION_REQUEST_ERROR",
} );
